import { VisitType } from '../models/visit-type';

export const visitTypes: VisitType[] = [
  {
    id: 1,
    description: 'Annual Wellness',
    isLocationSpecific: true,
  },
  {
    id: 2,
    description: 'Follow-Up Visit',
    isLocationSpecific: true,
  },
  {
    id: 3,
    description: 'Sick Visit',
    isLocationSpecific: true,
  },
  // {
  //   id: 4,
  //   description: 'Video: Follow-Up Visit',
  //   isLocationSpecific: false,
  // },
  // {
  //   id: 5,
  //   description: 'Video: Sick Visit',
  //   isLocationSpecific: false,
  // },
];
